import { AccountSettings } from 'fs-api-client';
import TransitionType = AccountSettings.TransitionTypeEnum;

export type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;
export type Subtract<T, K> = Omit<T, keyof K>;
export type Nullable<T> = T | null;

export { TransitionType };


// WEBPACK FOOTER //
// ./src/webportal/utils/types.tsx